/**
 * In development, use same-origin paths so CRA's `proxy` avoids CORS
 * (browser → localhost → api.hatproject.org). Override with REACT_APP_API_BASE_URL if needed.
 */


import { API_BASE_URL } from './constants/constants';

export function getApiBaseUrl() {
  return API_BASE_URL;
}

export function talktreesSignupIntentUrl() {
  return `${getApiBaseUrl()}v1/talktrees/signup-intent`;
}

export function talktreesCompleteFederatedUrl() {
  return `${getApiBaseUrl()}v1/talktrees/complete-federated-signup`;
}

export function talktreesCleanupFederatedUrl() {
  return `${getApiBaseUrl()}v1/talktrees/cleanup-federated-user`;
}

export function talktreesOnboardedUrl() {
  return `${getApiBaseUrl()}/v1/talktrees/onboarded`;
}